<template>
    <div>
        <div v-if="showRegionSelect" class="numbers-city" data-element="city-container">
            <template v-if="regionSelectMultiple">
                <div
                    class="order-unit"
                    data-element="chosen-city"
                    :key="branch.id"
                    v-for="branch in displayBranches"
                >
                    <span>{{ branch.name }}</span>
                    <a
                        href=""
                        class="order-unit_del"
                        data-element="remove-cross"
                        @click.prevent="removeBranch(branch)"
                        v-if="!isDemoVats"
                    >
                        <svg class="icon icon--close">
                            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon--close"></use>
                        </svg>
                    </a>
                </div>
                <div
                    class="order-unit add-city"
                    v-if="!isDemoVats"
                    @click="$emit('selectBranch')"
                >
                    <span>Добавить город</span>
                </div>
            </template>
            <template v-else>
                <div class="nums__region">
                    <span class="nums__gray">Город:</span>
                    <a
                        data-type="link"
                        data-element="nums__region"
                        class="nums__trigger"
                        @click="$emit('selectBranch')"
                    >
                        {{ displayBranches[0].name }}
                    </a>
                </div>
            </template>
        </div>

        <div class="numbers-help active" data-element="number-help-container" v-if="!isDemoVats">
            <div class="numbers-help_block">
                <div class="numbers-help-header">
                    <span
                        class="numbers-help-toggle-btn"
                        :class="{active: isExtFilter}"
                        data-element="help-trigger"
                        @click.prevent="toggleExtFilter"
                        v-if="showDetailSearch"
                    >
                        <span class="dashed">Расширенный поиск</span>
                    </span>
                    <form
                        class="numbers-help-search"
                        data-element="numbers-help"
                        @submit.prevent="submit(false)"
                    >
                        <input
                            type="text"
                            data-element="numbers-help-value"
                            placeholder="Введите часть номера"
                            v-imask="imask.query"
                            v-model="form.query"
                        />
                        <span class="numbers-help-search-icon"></span>
                        <input type="submit" value="" class="numbers-help-search-btn">
                        <span
                            class="numbers-help-reset"
                            data-element="help-reset"
                            v-if="form.query"
                            @click="clearQuery"
                        >
                            <span class="dashed">Отменить</span>
                        </span>
                    </form>
                </div>
                <div data-element="numbers-help-block" v-if="isExtFilter">
                    <ul class=" nav-tabs" data-element="filter-tabs">
                        <li
                            role="presentation"
                            :class="{active: selectedTab === tab.id}"
                            :key="tab.id"
                            v-for="tab in tabs"
                        >
                            <a
                                href=""
                                :aria-controls="tab.id"
                                @click.prevent="selectTab(tab.id)"
                            >{{ tab.title }}</a>
                        </li>
                    </ul>
                    <div class="tab-content">
                        <div
                            role="tabpanel"
                            class="tab-pane"
                            :class="{active: selectedTab === constant.tab.lucky}"
                            :id="constant.tab.lucky"
                        >
                            <div class="numbers-filter filter-lucky">
                                <form @submit.prevent="submit(true)">
                                    <div class="filter-lucky_item fav">
                                        <span>Укажите число (до 4 цифр)</span>
                                        <input
                                            type="text"
                                            maxlength="4"
                                            id="luck_number_text"
                                            v-imask="imask.digits"
                                            v-model="form.digits"
                                        />
                                    </div>
                                    <div class="filter-lucky_item">
                                        <label class="checkbox" data-element="lucky_begining" :class="{active: form.begins}">
                                            <input
                                                type="checkbox"
                                                data-element="num-filter-checkbox"
                                                hidden
                                                v-model="form.begins"
                                            />
                                            в начале номера
                                        </label>
                                    </div>
                                    <div class="filter-lucky_item">
                                        <label class="checkbox" data-element="lucky_middle" :class="{active: form.contains}">
                                            <input
                                                type="checkbox"
                                                data-element="num-filter-checkbox"
                                                hidden
                                                v-model="form.contains"
                                            />
                                            в середине
                                        </label>
                                    </div>
                                    <div class="filter-lucky_item">
                                        <label class="checkbox" data-element="lucky_end" :class="{active: form.ends}">
                                            <input
                                                type="checkbox"
                                                data-element="num-filter-checkbox"
                                                hidden
                                                v-model="form.ends"
                                            />
                                            в конце
                                        </label>
                                    </div>
                                    <div class="numbers-filter_item buttons">
                                        <input type="submit" class="btn sm" value="Подобрать" data-element="filter-luck-submit">
                                        <a
                                            href=""
                                            class="dashed"
                                            data-element="filter-reset"
                                            @click.prevent="reset"
                                        >Сбросить</a>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div
                            role="tabpanel"
                            class="tab-pane"
                            :class="{active: selectedTab === constant.tab.similar}"
                            :id="constant.tab.similar"
                        >
                            <form class="filter__similar filter-similar" @submit.prevent="submit(true)">
                                <div class="fields filter-similar_item" data-element="same_number_fields">
                                    <span>(XXX)</span>
                                    <div :key="'similar_item_' + i" v-for="(n, i) in 7">
                                        <input
                                            type="text"
                                            maxlength="1"
                                            ref="similarInput"
                                            v-imask="imask.similar"
                                            v-model="form.similar[i]"
                                            @input="moveCursorInSimilarInput(i + 1)"
                                            @keyup.right="moveCursorInSimilarInput(i + 1)"
                                            @keyup.left="moveCursorInSimilarInput(i - 1)"
                                        />
                                        <span v-if="n === 3 || n === 5">-</span>
                                    </div>
                                </div>
                                <div class="buttons">
                                    <input type="submit" class="btn sm" value="Подобрать" data-element="filter-similar-submit">
                                    <a
                                        href=""
                                        class="dashed"
                                        data-element="filter-reset"
                                        @click.prevent="reset"
                                    >Сбросить фильтры</a>
                                </div>
                                <div class="filter__result"></div>
                            </form>
                        </div>
                        <div
                            role="tabpanel"
                            class="tab-pane"
                            :class="{active: selectedTab === constant.tab.mask}"
                            :id="constant.tab.mask"
                        >
                            <form
                                class="filter-mask"
                                data-element="filter-mask"
                                @submit.prevent="submit(true)"
                            >
                                <div class="filter-mask_item">
                                    <a
                                        href=""
                                        data-element="filter-mask-label"
                                        :class="{active: mask.id === form.mask}"
                                        :key="mask.id"
                                        v-for="mask in masks"
                                        @click.prevent="form.mask = mask.id"
                                    >{{ mask.title }}</a>
                                </div>
                                <div class="buttons">
                                    <input type="submit" class="btn sm" value="Подобрать" data-element="filter-by-mask-submit">
                                    <a
                                        href=""
                                        class="dashed"
                                        data-element="filter-reset"
                                        @click.prevent="reset"
                                    >Сбросить фильтры</a>
                                </div>
                                <div class="filter__result"></div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="numbers-type pos-r" v-if="!isDemoVats">
            <div
                v-if="motivationPopoverContent"
                v-html="motivationPopoverContent"
            />
            <div class="numbers-type_items" data-element="numbers-items">
                <a
                    href=""
                    :class="[item.code + '-tab', {active: item.code === category, disabled:!displayCounters[item.code]}]"
                    data-element="numbers-tab"
                    :key="item.code"
                    v-for="item in categories"
                    @click.prevent="selectCategory(item)"
                >
                    {{ item.name }} <span>({{ displayCounters[item.code] }})</span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import ModelCategory from '../models/category.js';
import {IMaskDirective} from 'vue-imask'

import message from '../../../lib/message.js'

const constant = {
    tab: {
        lucky: 'luckynumber',
        similar: 'similarnumber',
        mask: 'masknumber'
    },
    mask: {
        xyxy: 'XY-XY',
        x0y0z0: 'X0-Y0-Z0',
        xyz: '123',
    }
};

export default {
    name: "NumbersFilter",
    emits: ['selectBranch', 'update:category', 'applyFilter'],
    directives: {
        imask: IMaskDirective
    },
    props: {
        showRegionSelect: {
          type: Boolean,
          default: true
        },
        regionSelectMultiple: {
          type: Boolean,
          default: false
        },
        showDetailSearch: {
          type: Boolean,
          default: false
        },
        branches: {
            type: Array
        },
        counters: {
            type: Array
        },
        category: {
            type: String
        },
        isDemoVats: {
          type: Boolean,
          default: false
        },
        motivationPopoverContent: {
            type: String
        }
    },
    data () {
        return {
            constant: constant,
            isExtFilter: false,
            selectedTab: constant.tab.lucky,
            tabs: [
                {
                    id: constant.tab.lucky,
                    title: 'Счастливое число'
                },
                {
                    id: constant.tab.similar,
                    title: 'Похожий номер'
                },
                {
                    id: constant.tab.mask,
                    title: 'Подбор по маске'
                }
            ],
            masks: [
                {
                    id: constant.mask.xyxy,
                    title: 'XY-XY'
                },
                {
                    id: constant.mask.x0y0z0,
                    title: 'X0-Y0-Z0'
                },
                {
                    id: constant.mask.xyz,
                    title: '3 цифры по порядку'
                }
            ],
            categories: [
                new ModelCategory(ModelCategory.constants.code.usual, 'Обычные'),
                new ModelCategory(ModelCategory.constants.code.silver, 'Серебряные'),
                new ModelCategory(ModelCategory.constants.code.gold, 'Золотые'),
                new ModelCategory(ModelCategory.constants.code.platinum, 'Платиновые'),
                new ModelCategory(ModelCategory.constants.code.exclusive, 'Эксклюзивные')
            ],
            imask: {
                query: {
                    mask: /^[0-9]{0,10}$/
                },
                digits: {
                    mask: /^[0-9]{0,4}$/
                },
                similar: {
                    mask: '0'
                }
            },
            form: {
                query: '',
                digits: '',
                begins: true,
                contains: true,
                ends: true,
                similar: ['', '', '', '', '', '', ''],
                mask: null
            },
            filter: null
        };
    },
    computed: {
        displayBranches () {
            if (!Array.isArray(this.branches)) {
                return []
            }
            return this.branches.filter(branch => branch.selected)
        },
        displayCounters () {
            let counters = {};
            this.categories.forEach(category => {
                counters[category.code] = 0;
            });
            if (Array.isArray(this.counters)) {
                this.counters.forEach(category => {
                    if (Object.hasOwnProperty.call(counters, category.code)) {
                        counters[category.code] = category.count;
                    }
                });
            }
            return counters;
        }
    },
    watch: {
        displayBranches () {
            this.applyFilter()
        }
    },
    mounted () {
        this.applyFilter()
    },
    methods: {
        toggleExtFilter () {
            this.isExtFilter = !this.isExtFilter;
        },
        selectTab (id) {
            if (this.selectedTab !== id) {
                this.selectedTab = id;
            }
        },
        selectCategory (category) {
            if (this.category !== category.code) {
                this.$emit('update:category', category.code);
                this.applyFilter();
            }
        },
        removeBranch (branch) {
            branch.selected = false;
        },
        updateValueInSimilarInput (index, value) {
            console.log(index, value);
            this.form.similar[index] = value;
        },
        moveCursorInSimilarInput (index, clearIndex) {
            if (clearIndex !== undefined) {
                this.form.similar[clearIndex] = '';
            }
            if (index >= 0 && index < 7) {
                console.log(index);
                let input = this.$refs.similarInput[index];
                input.focus();
                input.setSelectionRange(0, input.value.length);
            }
        },
        clearQuery () {
            this.form.query = '';
            this.submit();
        },
        reset () {
            this.form.digits = '';
            this.form.mask = null;

            let similar = [];
            for (let i = 0; i < 7; i++) {
                similar[i] = '';
            }
            this.form.similar = similar;

            this.submit();
        },
        submit (check) {
            let filter = {};
            let isFiltered = false;

            if (this.form.query) {
                filter.query = this.form.query;
                isFiltered = true;
            }

            let error = null;

            if (this.isExtFilter) {
                switch (this.selectedTab) {
                    case constant.tab.lucky: {
                        if (this.form.digits) {
                            if (this.form.begins || this.form.contains || this.form.ends) {
                                filter.digits = this.form.digits;
                                if (this.form.begins) {
                                    filter.begins = 1;
                                }
                                if (this.form.contains) {
                                    filter.contains = 1;
                                }
                                if (this.form.ends) {
                                    filter.ends = 1;
                                }
                                isFiltered = true;
                            } else {
                                error = 'Отсутствуют параметры подбора номеров';
                            }
                        } else {
                            error = 'Укажите число';
                        }
                        break;
                    }
                    case constant.tab.similar: {
                        let similar = this.form.similar.join('');
                        if (similar.length === 7) {
                            filter.similar = similar;
                            isFiltered = true;
                        } else {
                            error = 'Необходимо ввести все цифры номера';
                        }
                        break;
                    }
                    case constant.tab.mask: {
                        if (this.form.mask) {
                            filter.mask = this.form.mask;
                            isFiltered = true;
                        } else {
                            error = 'Выберите маску';
                        }
                        break;
                    }
                }
            }

            if (error && check === true) {
                message.showError(error);
                return;
            }

            if (
                this.filter !== null
                && JSON.stringify(this.filter) === JSON.stringify(filter)
            ) {
                return;
            }

            this.filter = filter;
            this.applyFilter(isFiltered);
        },
        applyFilter (isFiltered) {
            this.$nextTick(() => {
                let filter = this.filter ? Object.assign({}, this.filter) : {};
                filter.branch_id = this.displayBranches.map(branch => branch.id);
                filter.beauty = [this.category];
                this.$emit('applyFilter', filter, isFiltered === true, this.getHighlightPatterns(filter));
            })
        },
        getHighlightPatterns (filter) {
            let patterns = [];

            if (filter) {
                if (Array.isArray(filter.beauty)) {
                    if (filter.beauty.indexOf(ModelCategory.constants.code.gold) > -1 ||
                        filter.beauty.indexOf(ModelCategory.constants.code.exclusive) > -1 ||
                        filter.beauty.indexOf(ModelCategory.constants.code.platinum) > -1) {
                        for (let i = 0; i < 10; i++) {
                            patterns.push('[' + i + ']{2,7}');
                        }
                        for (let i = 10; i < 100; i++) {
                            patterns.push('(' + i + '){2,3}');
                        }
                    }
                }

                if (filter.digits) {
                    if (filter.begins) {
                        patterns.push('^' + filter.digits);
                    }
                    if (filter.contains) {
                        patterns.push('(?!^)' + filter.digits + '(?!$)');
                    }
                    if (filter.ends) {
                        patterns.push('' + filter.digits + '$');
                    }
                }

                if (filter.similar) {
                    for (let i = 0, l = filter.similar.length; i < l; i++) {
                        let pattern = '';
                        if (i > 0) {
                            pattern += '(?<=\\d{' + i + '})';
                        }
                        pattern += filter.similar.charAt(i);
                        if (i < (l - 1)) {
                            pattern += '(?=\\d{' + (l - i - 1) + '})';
                        }
                        patterns.push(pattern);
                    }
                }

                if (filter.mask) {
                    switch (filter.mask) {
                        case constant.mask.xyxy: {
                            patterns.push('(?<xyxy>[0-9]{2})\\k<xyxy>');
                            break;
                        }
                        case constant.mask.x0y0z0: {
                            patterns.push('([0-9]0){3}');
                            break;
                        }
                        case constant.mask.xyz: {
                            patterns.push('012');
                            patterns.push('123');
                            patterns.push('234');
                            patterns.push('345');
                            patterns.push('456');
                            patterns.push('567');
                            patterns.push('678');
                            patterns.push('789');
                            break;
                        }
                    }
                }

                if (filter.query) {
                    patterns.push(filter.query);
                }
            }

            return patterns;
        }
    }
}
</script>

<style lang="scss">
.numbers {
    .numbers-help-reset {
        display: block !important;
    }

    .filter-similar_item {

        div {
            display: inline-block;

            input {
                margin: 0 2px;
            }
        }
    }

    .numbers-help .numbers-help-search{
        input[type=text] {
            padding-left: 40px;
        }
    }

    .numbers-help-toggle-btn {
        padding-left: 24px;
        position: relative;
        color: #37474f;

        .dashed {
            border-bottom: none;
        }

        &:before {
            content: '';
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            margin: auto;
            height: 20px;
            width: 20px;
            background: url(/static_files_new/scss/blocks/8800/img/arr.svg) center no-repeat;
            transform: rotate(180deg);
        }

        &.active {
            &:before {
                transform: none;
            }
        }
    }

    .numbers-help-search-icon {
        right: auto;
        left: 0;
        background: url(/static_files_new/scss/blocks/8800/img/lens.svg) center no-repeat;
    }
}
</style>